// frontend_react/src/pages/admin/ReplenishmentStatusPage.jsx

import React, { useEffect, useState } from 'react';
import { PageContainer, PageTitle, Table, ErrorText } from '../../ui';
import { getReplenishmentStatus } from "../../services/replenishmentApi";
import { useAdminScope } from "../../context/AdminScopeContext";

export default function ReplenishmentStatusPage() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { selectedCompanyUuid } = useAdminScope();

  useEffect(() => {
    async function fetchStatus() {
      setLoading(true);
      try {
        const res = await getReplenishmentStatus({
          companyUuid: selectedCompanyUuid,
        });
        setData(res);
        setError(null);
      } catch (err) {
        setError(
          err.response?.data?.error ||
            'Erreur lors du chargement du statut.'
        );
      } finally {
        setLoading(false);
      }
    }
    fetchStatus();
  }, [selectedCompanyUuid]);

  return (
    <PageContainer>
      <PageTitle>Suivi des réceptions</PageTitle>
      {loading ? (
        <p>Chargement…</p>
      ) : error ? (
        <ErrorText>{error}</ErrorText>
      ) : (
        <Table>
          <thead>
            <tr>
              <th>Statut</th>
              <th>Nombre</th>
            </tr>
          </thead>
          <tbody>
            {Object.entries(data).map(([status, count]) => (
              <tr key={status}>
                <td>{status}</td>
                <td>{count}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </PageContainer>
  );
}